<template>
	<div class="ExaminationIdentityOk sw-container">
		<div class="common-nav">
			<span class="s1">您的位置</span>
			<span class="s2">|</span>
			<span class="s1">考试</span>
			<span class="s2">|</span>
			<span class="s3">身份确认</span>
		</div>
		<div class="ExaminationIdentityOk-main">
			<div class="ExaminationIdentityOk-search">
				<Input v-model="search" placeholder="请输入课程名" />
				<img src="../../assets/img/search.png" />
			</div>
			<div class="ExaminationIdentityOk-center">
				<div class="ExaminationIdentityOk-center-title">身份确认</div>
				<div class="ExaminationIdentityOk-center-title2">首次参加考试需身份确认</div>
				<Form class="ExaminationIdentityOk-form" ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
					<FormItem class="ExaminationIdentityOk-form-item" label="姓名" prop="name">
						<Input v-model="formValidate.name" placeholder="请输入姓名"></Input>
					</FormItem>
					<FormItem class="ExaminationIdentityOk-form-item" label="年龄" prop="age">
						<Input v-model="formValidate.age" placeholder="请输入年龄"></Input>
					</FormItem>
					<FormItem class="ExaminationIdentityOk-form-item" label="身份证号" prop="idCard">
						<Input v-model="formValidate.idCard" placeholder="请输入身份证号"></Input>
					</FormItem>
					<FormItem class="ExaminationIdentityOk-form-item" label="联系电话" prop="phone">
						<Input v-model="formValidate.phone" placeholder="请输入联系电话"></Input>
					</FormItem>
					<FormItem class="ExaminationIdentityOk-form-item" label="性别" prop="sex">
						<Select v-model="formValidate.sex" placeholder="请选择性别">
							<Option value="0">男</Option>
							<Option value="1">女</Option>
						</Select>
					</FormItem>
					<FormItem class="ExaminationIdentityOk-form-item" label="证书类型" prop="type">
						<Select v-model="formValidate.type" placeholder="请选择证书类型">
							<Option value="0">男</Option>
							<Option value="1">女</Option>
						</Select>
					</FormItem>
					<FormItem class="ExaminationIdentityOk-form-item" label="所在城市" prop="city">
						<Select v-model="formValidate.city" placeholder="请选择所在城市">
							<Option value="0">男</Option>
							<Option value="1">女</Option>
						</Select>
					</FormItem>
					<FormItem class="ExaminationIdentityOk-form-item" label="证书编号" prop="num">
						<Input v-model="formValidate.num" placeholder="请输入证书编号"></Input>
					</FormItem>
				</Form>
				<div class="ExaminationIdentityOk-btn">确认考试</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ExaminationIdentityOk',
		components: {},
		data() {
			return {
				search: '',
				formValidate: {},
				ruleValidate: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					age: [{
							required: true,
							message: '请输入年龄',
							trigger: 'blur'
						},
						{
							pattern: /^\d+$/,
							message: '请输入数字',
							trigger: 'blur'
						}

					],
					idCard: [{
							required: true,
							message: '请输入身份证',
							trigger: 'blur'
						},
						{
							pattern: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
							message: '请输入正确的身份证',
							trigger: 'blur'
						},
					],
					phone: [{
							required: true,
							message: '请输入联系电话',
							trigger: 'blur'
						},
						{
							pattern: /^1\d{10}$/,
							message: '请输入正确的手机号',
							trigger: 'blur'
						},
					],
					sex: [{
						required: true,
						message: '请选择性别',
						trigger: 'change'
					}],
					type: [{
						required: true,
						message: '请选择证书类型',
						trigger: 'change'
					}],
					city: [{
						required: true,
						message: '请选择所在城市',
						trigger: 'change'
					}],
					num: [{
						required: true,
						message: '请输入证书编号',
						trigger: 'blur'
					}]
				}
			}
		},
		created() {},
		computed: {},
		methods: {
			handleChangePage() {

			}
		},
		watch: {}
	}
</script>

<style lang="scss">
	.ExaminationIdentityOk {
		padding-bottom: 30px;
		&-main {
			background: #FBFBFB;
		}
		&-search {
			margin: 0 auto;
			padding: 13px 0;
			width: 748px;
			position: relative;
			img {
				position: absolute;
				right: 20px;
				top: 21px;
				cursor: pointer;
			}
			.ivu-input {
				height: 40px;
				padding-left: 20px;
			}
		}
		&-center {
			border-top: 1px solid #F0F1F4;
			height: 490px;
			background: #fff;
			padding-top: 30px;
			&-title {
				color: #222222;
				font-size: 24px;
				line-height: 1;
				text-align: center;
				margin-bottom: 12px;
			}
			&-title2 {
				text-align: center;
				color: #EB020B;
				font-size: 14px;
				margin-bottom: 46px;
			}
		}
		&-form {
			display: flex;
			flex-wrap: wrap;
			padding-left: 70px;
			&-item {
				width: 50%;
			}
			.ivu-form-item-content {
				width: 320px;
			}
			.ivu-form-item-required .ivu-form-item-label:before {
				content: '';
			}
			.ivu-form-item-label {
				color: #222222;
			}
			.ivu-input {
				height: 36px;
				line-height: 36px;
			}
			.ivu-select-single .ivu-select-selection {
				height: 36px;
			}
			.ivu-select-single .ivu-select-selection .ivu-select-placeholder {
				height: 36px;
				line-height: 36px;
			}
			.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
				height: 36px;
				line-height: 36px;
			}
		}
		&-btn {
			width: 120px;
			height: 40px;
			background: rgba(55, 188, 95, 1);
			border-radius: 4px;
			font-size: 14px;
			color: #fff;
			text-align: center;
			line-height: 40px;
			cursor: pointer;
			margin: 40px auto 0;
		}
		&-btn:hover {
			background: rgba(55, 188, 95, .8);
		}
	}
</style>